export interface IInvoiceDetailTotal {
    isSummary: boolean,
    transplantCount: number,

    amountDue: number,
    lineItemTotal: number,

    amountPaid: number,

    annualMembershipFee: number,

    annualDcnFee: number,

    technologySupportFee: number,

    customLineItemFee: number,

    nkrFee: number,

    dashFee: number,

    crossMatchFee: number,

    crossMatchKitFee: number,

    crossMatchVibtFee: number,

    vxmFee: number,

    serologyFee: number,

    serologyFeeDirect: number,

    serologyKitFee: number,

    logisticsFee: number,
    logisticsFeeLiver: number,

    shippingFee: number,

    transplantFee: number,

    transplantLiverFee: number,

    opoFee: number,

    dppFee: number,

    patientTypingFee: number,
    typingFee: number,
    typingSwabKit: number,
    typingAndCryoFee: number,
    typingCryoKit: number,

    researchSupportFee: number,

    micrositeSupportFee: number,

    donorInsuranceAndSupport: number,
    donorInsuranceAndSupportLiver: number,
    donorShieldCredits: number,
    donorShieldCreditsLiver: number,

    ctFee: number,

    medicaidFee: number,

    homeBloodDrawFee: number,
    homeBloodDrawKit: number,

    covid19Fee: number,

    phlebotFee: number,

    donorShieldFee: number,

    donorShieldLiverFee: number,

    pwlQuestFee: number,

    pwlPhlebotFee: number,

    pwlJugOnlyFee: number,

    physicianCharge: number,

    anesthesiaCharge: number,

    hospitalCharge: number,

    pwlPerTransplantFee: number,
    rmcrFeeMinor: number,
    rmcrFeeMajor: number,


    streamlinedHospitalBillingFee: number,
    streamlinedBillingFee: number,
    donorWorkupFee: number,

    dashFeeLiver: number,
    transplantTypingFee: number,
    remoteRiskPremium: number,
    incompatiblePairRiskPremium: number,
    privateInsuranceRiskPremium: number,
    pwlPhlebotKit: number,

    miscLineItemTotal: number,

    monthlyInactivityFee: number,
    lostGpsFee: number,
    stateTaxes: number
}